import {encode} from '../../../../utils/base64'

export default async function encodeBase64(input, {urlSafeMode} = {urlSafeMode: false}) {
  return encode(input, {urlSafeMode})
}
